<div class="overlay-spinner" *ngIf="LoaderStatus">
  <div class="d-flex justify-content-center">
    <div class="spinner-border text-warning" style="width: 3rem; height: 3rem; " role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>
<app-alert [Type]="AlertType" [View]="AlertStatus" [Message]="AlertMessage"></app-alert>
<div class="mx-5 pb-5">
  <app-pages-header></app-pages-header>
  <div class="row bg-white bottom-page-shadow mx-1 ">
    <div class="col pt-3 pb-3 shadow rounded-bottom">
      <p><strong>Pembayar Cukai</strong> - Penerimaan Pelantikan Ejen Cukai</p>

      <!-- detail acordion -->
      <div class="accordion m-3">
        <div class="accordion-item border-0 ">
          <h2 class="accordion-header shadow m-0 " id="panel-header">
            <button class="accordion-button primary-colour text-black rounded-top-extra" type="button" data-bs-toggle="collapse" data-bs-target="#panel-body" aria-expanded="true" aria-controls="panel-body">
              Butiran Permohonan Telah Diterima
            </button>
          </h2>
          <div id="panel-body" class="accordion-collapse collapse show shadow" style="background-color: #F5F5F5;" aria-labelledby="panel-header">
            <div class="accordion-body">
              <div class="row">
                <div class="col-2">
                  <p>Pembayar Cukai</p>
                </div>
                <div class="col-1">
                  <p class="text-end">:</p>
                </div>
                <div class="col-4">
                  <p><strong>{{TaxpayerNameView}}</strong></p>
                </div>
              </div>

              <div class="row">
                <div class="col-2">
                  <p>No. Pengenalan / No. Pendaftaran</p>
                </div>
                <div class="col-1 text-end">
                  <p>:</p>
                </div>
                <div class="col-2">
                  <p><strong>{{TaxpayerIDNoView}}</strong></p>
                </div>
                <div class="col-2 offset-1">
                  <p>TIN</p>
                </div>
                <div class="col-1">
                  <p class="text-end">:</p>
                </div>
                <div class="col-2">
                  <p><strong>{{TaxpayerItGrpView}} {{TaxpayerTINView}}</strong></p>
                </div>
              </div>

              <div class="row">
                <div class="col-2">
                  <p>No. Telefon</p>
                </div>
                <div class="col-1">
                  <p class="text-end">:</p>
                </div>
                <div class="col-2">
                  <p><strong>{{TaxpayerPhoneNoCountryCodeNo}} {{TaxpayerPhoneNoView}}</strong></p>
                </div>
                <div class="col-2 offset-1">
                  <p>Emel</p>
                </div>
                <div class="col-1 text-end">
                  <p>:</p>
                </div>
                <div class="col-2">
                  <p><strong>{{TaxpayerEmailView}}</strong></p>
                </div>
              </div>

              <div class="row pt-5">
                <div class="col-2">
                  <p>Ejen Cukai Yang Dilantik</p>
                </div>
                <div class="col-1">
                  <p class="text-end">:</p>
                </div>
                <div class="col-3">
                  <p><strong>{{TaxAgentNameView}}</strong></p>
                </div>
                <div class="col-2 ">
                  <p>Firma Ejen Cukai</p>
                </div>
                <div class="col-1 text-end">
                  <p>:</p>
                </div>
                <div class="col-3">
                  <p><strong>{{FirmNameView}}</strong></p>
                </div>
              </div>

              <div class="row">
                <div class="col-2">
                  <p>Status</p>
                </div>
                <div class="col-1 text-end">
                  <p>:</p>
                </div>
                <div class="col-3">
                  <p class="text-uppercase"><strong>{{StatusView}}</strong></p>
                </div>
              </div>

              <div class="row pt-5" *ngIf="StatusView !== 'Baharu'">
                <div class="col-2">
                  <p>{{StatusView !== 'Dibatalkan' ? StatusNamingView : 'Diluluskan'}} Oleh</p>
                </div>
                <div class="col-1 text-end">
                  <p>:</p>
                </div>
                <div class="col-3">
                  <p><strong>{{AdminName}}</strong></p>
                </div>
                <div class="col-2">
                  <p>Tarikh {{StatusView !== 'Dibatalkan' ? StatusNamingView : 'Diluluskan'}}</p>
                </div>
                <div class="col-1 text-end">
                  <p>:</p>
                </div>
                <div class="col-3">
                  <p><strong>{{ActionDateView}}</strong></p>
                </div>
              </div>

              <div class="row" *ngIf="StatusView !== 'Baharu'">
                <div class="col-2">
                  <p>Huraian {{StatusView !== 'Dibatalkan' ? StatusNamingView : 'Diluluskan'}}</p>
                </div>
                <div class="col-1 text-end">
                  <p>:</p>
                </div>
                <div class="col-9">
                  <p><strong>{{RemarksView}}</strong></p>
                </div>
              </div>

              <div class="row pt-5" *ngIf="StatusView === 'Dibatalkan'">
                <div class="col-2">
                  <p>Dibatalkan Oleh</p>
                </div>
                <div class="col-1 text-end">
                  <p>:</p>
                </div>
                <div class="col-3">
                  <p class="text-uppercase"><strong>{{RevokeByNameView}}</strong></p>
                </div>
                <div class="col-2" *ngIf="RevokeDateView !== 'N/A'">
                  <p>Tarikh Batal</p>
                </div>
                <div class="col-1 text-end" *ngIf="RevokeDateView !== 'N/A'">
                  <p>:</p>
                </div>
                <div class="col-2" *ngIf="RevokeDateView !== 'N/A'">
                  <p><strong>{{RevokeDateView}}</strong></p>
                </div>
              </div>

              <div *ngIf="StatusView === 'Dibatalkan'" class="row">
                <div class="col-2">
                  <p>Huraian Batal</p>
                </div>
                <div class="col-1 text-end">
                  <p>:</p>
                </div>
                <div class="col-9">
                  <p><strong>{{AgentRemarksView}}</strong></p>
                </div>
              </div>

              <div class="row bg-white shadow rounded-3 mt-3 pt-3 pb-3">
                <div class="col-1">
                  <p><strong>Akses Diberi</strong></p>
                </div>
                <div class="col-1">
                  <p class="text-end">:</p>
                </div>
                <div class="col-auto">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" [disabled]="true" [checked]="EBorangAccessView">
                    <label class="form-check-label" for="penghantaran-borang">
                      Penghantaran e-Borang
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" [disabled]="true" [checked]="LejarAccessView">
                    <label class="form-check-label" for="status-mytax">
                      Status MyTax
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" [disabled]="true" [checked]="ProfileAccessView">
                    <label class="form-check-label" for="kemaskini-profil">
                      Paparan Profil
                    </label>
                  </div>
                </div>
              </div>



              <div class="btn-toolbar d-flex justify-content-center pt-5 pb-5">
                <div class="me-2" *ngIf="ProcessButtonStatus">
                  <button type="button" class="btn submit-primary-button border-0 shadow rounded-4 bg-white" role="button" data-bs-toggle="modal" data-bs-target="#rejectModal">Tolak</button>
                </div>
                <div class="me-2" *ngIf="ProcessButtonStatus">
                  <button type="button" class="btn submit-primary-button  border-0 shadow rounded-4 bg-white" role="button" data-bs-toggle="modal" data-bs-target="#approveModal">Terima</button>
                </div>
                <div class="me-2" *ngIf="FormButtonStatus">
                  <button type="button" class="btn submit-primary-button border-0 shadow rounded-4 bg-white" role="button" (click)="EBorangClick(TaxpayerTINView)">e-Borang</button>
                </div>
                <div class="me-2" *ngIf="LedgerButtonStatus">
                  <button type="button" class="btn submit-primary-button  border-0 shadow rounded-4 bg-white" role="button" (click)="StatusMyTax(TaxpayerTINView)">Status MyTax</button>
                </div>
                <div class="me-2" *ngIf="ProfileButtonStatus">
                  <button type="button" class="btn submit-primary-button  border-0 shadow rounded-4 bg-white" role="button" (click)="UpdateProfile(TaxpayerTINView)">Paparan Profil</button>
                </div>
                <div class="me-2" *ngIf="RevokeButtonStatus">
                  <button type="button" class="btn submit-primary-button  border-0 shadow rounded-4 bg-white" role="button" data-bs-toggle="modal" data-bs-target="#cancelModal">Batal Lantikan</button>
                </div>
                <div class="me-2">
                  <button type="button" class="btn submit-primary-button  border-0 shadow rounded-4 bg-white" role="button" (click)="Back()">Kembali</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- e-Borang acordion -->
      <div class="accordion m-3 pt-4" id="resultAcordion" *ngIf="EBorangStatus">
        <div class="accordion-item border-0">
          <h2 class="accordion-header m-0" id="headingOne">
            <button class="accordion-button primary-colour text-black shadow rounded-top-extra" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
              e-Borang
            </button>
          </h2>
          <div id="collapseOne" class="accordion-collapse collapse show bottom-page-shadow default-content-bg-colour rounded-bottom-extra" aria-labelledby="headingOne" data-bs-parent="#resultAcordion">
            <div class="accordion-body">

              <div class="row pt-3">
                <div class="col-2">
                  <select class="form-select border-0 shadow" [(ngModel)]="FormTypeInput" [ngModelOptions]="{standalone: true}" (change)="ChangeFormTypeRegister(FormTypeInput)">
                    <option value="">Jenis Borang</option>
                    <option *ngFor="let res of FormTypeList" [value]="res.formName">e-{{res.formName}}</option>
                  </select>
                </div>
                <div class="col-2" *ngIf="YearAssessmentRegisterStatus">
                  <ng-container *ngFor="let arrays of YearAssessmentList">
                    <select class="form-select border-0 shadow" [(ngModel)]="YearAssessmentInput" [ngModelOptions]="{standalone: true}">
                      <option value="">Tahun Taksiran</option>
                      <option *ngFor="let res of arrays" [value]="res">{{res}}</option>
                    </select>
                  </ng-container>
                </div>
                <div class="col-3">
                  <div class="btn-toolbar d-flex justify-content-center">
                    <div class="me-2">
                      <button type="button" class="btn submit-primary-button border-0 shadow rounded-2" role="button" (click)="RegisterForm(FormTypeInput,YearAssessmentInput,TaxAgentIDView,TaxpayerTINView)">Daftar</button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="example-table-container pt-5">
                <p class="fw-bold">Senarai Borang Didaftar Firma</p>
                <table mat-table [dataSource]="dataSource" class="w-100 shadow">
                  <ng-container matColumnDef="jenisborang">
                    <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Jenis Borang</th>
                    <td class="text-center" mat-cell *matCellDef="let res">{{res.jenis_Borang}}</td>
                  </ng-container>
                  <ng-container matColumnDef="staffname">
                    <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Nama Staf</th>
                    <td class="text-center" mat-cell *matCellDef="let res">{{res.staffName}}</td>
                  </ng-container>
                  <ng-container matColumnDef="agentname">
                    <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Nama Ejen Cukai</th>
                    <td class="text-center" mat-cell *matCellDef="let res">{{res.agentName}}</td>
                  </ng-container>
                  <ng-container matColumnDef="tarikhdaftar">
                    <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Tarikh Daftar</th>
                    <td class="text-center" mat-cell *matCellDef="let res">{{res.dateRegister}}</td>
                  </ng-container>
                  <ng-container matColumnDef="tarikhhantar">
                    <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Tarikh Hantar</th>
                    <td class="text-center" mat-cell *matCellDef="let res">{{res.dateSubmit}}</td>
                  </ng-container>
                  <ng-container matColumnDef="action">
                    <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Tindakan</th>
                    <td mat-cell *matCellDef="let res">
                      <div class="btn-toolbar d-flex justify-content-center">
                        <div class="me-2" *ngIf="res.distributeAccess">
                          <button type="button" class="btn sec-button border-0 shadow rounded-2" role="button" data-bs-toggle="modal" data-bs-target="#agihSemulaModal" (click)="Distribute(res.taxReturnForm_ID,res.userID,TaxpayerNameView, res.jenis_Borang, res.agentID, res.staffName, TaxpayerTINView, res.dateRegister)">Agih Semula</button>
                        </div>
                        <div class="me-2" *ngIf="res.acknowledgementAccess">
                          <button type="button" class="btn sec-button border-0 shadow rounded-2" role="button" (click)="GetAcknowledment(res.jenis_Borang,res.formYear,TaxpayerTINView)">Semakan</button>
                        </div>
                        <div class="me-2" *ngIf="res.resetAccess">
                          <button type="button" class="btn sec-button border-0 shadow rounded-2" role="button" data-bs-toggle="modal" data-bs-target="#setSemulaModal" (click)="ResetFormValue(TaxpayerTINView,res.jenis_Borang,res.formYear)">Set Semula</button>
                        </div>
                        <div class="me-2" *ngIf="res.loginAccess">
                          <button type="button" (click)="LoginForm(res.taxReturnForm_ID,res.jenis_Borang)" class="btn sec-button border-0 shadow rounded-2" role="button">Login</button>
                        </div>
                      </div>
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                  <tr mat-row *matRowDef="let test;columns:displayedColumns"></tr>
                  <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell text-center" colspan="10">Tiada Rekod</td>
                  </tr>
                </table>
              </div>

              <div class="example-table-container pt-5">
                <p class="fw-bold">Senarai Borang Bukan Didaftar Firma</p>
                <table mat-table [dataSource]="dataSourceOtherFirm" class="w-100 shadow">
                  <ng-container matColumnDef="jenisborang">
                    <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Jenis Borang</th>
                    <td class="text-center" mat-cell *matCellDef="let res">{{res.jenis_Borang}}</td>
                  </ng-container>
                  <ng-container matColumnDef="tarikhdaftar">
                    <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Tarikh Daftar</th>
                    <td class="text-center" mat-cell *matCellDef="let res">{{res.dateRegister}}</td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumnsOtherFirm; sticky: true"></tr>
                  <tr mat-row *matRowDef="let test;columns:displayedColumnsOtherFirm"></tr>
                  <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell text-center" colspan="10">Tiada Rekod</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Reject Modal -->
<div class="modal fade" id="rejectModal" tabindex="-1" aria-labelledby="rejectModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content pb-5" style="background-color: #E8E8E8 !important;">
      <div class="modal-body">
        <div class="d-flex justify-content-end align-items-end pb-3">
          <button class="btn" #rejectCloseButton data-bs-dismiss="modal"><i class="bi bi-x-square-fill"></i></button>

        </div>
        <div class="row rounded-top-extra primary-colour shadow mx-3">
          <div class="col pt-2">
            <p>Sila nyatakan huraian anda kerana menolak Penerimaan Pelantikan</p>
          </div>
        </div>
        <div class="row rounded-bottom-extra shadow mx-3 default-content-bg-colour">
          <div class="col m-3">
            <div class="form-floating shadow">
              <textarea class="form-control border-0" maxlength="150" placeholder="Huraian / Penjelasan :" id="huraianTextArea" style="height: 10rem" [(ngModel)]="ProcessRemarks" [ngModelOptions]="{standalone: true}"></textarea>
              <label class="text-muted" for="huraianTextArea">Huraian / Penjelasan :</label>
            </div>
          </div>
          <div class="d-flex justify-content-center align-items-center p-5">
            <button type="button" style="width: 20rem;" class="btn submit-primary-button border-0 shadow rounded-4" (click)="ProcessLantikan('Ditolak',ProcessRemarks)">Hantar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Approve Modal -->
<div class="modal fade" id="approveModal" tabindex="-1" aria-labelledby="approveModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content pb-5" style="background-color: #E8E8E8 !important;">
      <div class="modal-body">
        <div class="d-flex justify-content-end align-items-end pb-3">
          <button class="btn" data-bs-dismiss="modal"><i class="bi bi-x-square-fill"></i></button>

        </div>
        <div class="row rounded-top-extra primary-colour shadow mx-3">
          <div class="col pt-2">
            <p>Adakan anda pasti untuk menerima lantikan?</p>
          </div>
        </div>
        <div class="row rounded-bottom-extra shadow mx-3 default-content-bg-colour">
          <div class="col m-3">
            <div class="form-floating shadow">
              <textarea class="form-control border-0" maxlength="150" placeholder="Huraian / Penjelasan :" id="huraianTextArea" style="height: 10rem" [(ngModel)]="ProcessRemarks" [ngModelOptions]="{standalone: true}"></textarea>
              <label class="text-muted" for="huraianTextArea">Huraian / Penjelasan :</label>
            </div>
          </div>
          <div class="d-flex justify-content-center align-items-center p-5">
            <button type="button" style="width: 20rem;" class="btn submit-primary-button border-0 shadow rounded-4" data-bs-dismiss="modal" (click)="ProcessLantikan('Diluluskan',ProcessRemarks)">Hantar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Agih Semula Modal -->
<div class="modal fade" id="agihSemulaModal" tabindex="-1" aria-labelledby="agihSemulaModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content pb-5" style="background-color: #E8E8E8 !important;">
      <div class="modal-body">
        <div class="d-flex justify-content-end align-items-end pb-3">
          <button class="btn" data-bs-dismiss="modal"><i class="bi bi-x-square-fill"></i></button>

        </div>
        <div class="row rounded-top-extra primary-colour shadow mx-3">
          <div class="col pt-2">
            <p>Agih Semula</p>
          </div>
        </div>
        <div class="row rounded-bottom-extra shadow mx-3" style="background-color: #F5F5F5 !important;">
          <div class="col m-3">
            <div class="row">
              <div class="col-2">
                <p>Pembayar Cukai</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-auto">
                <p><strong>{{DistributeTaxpayerNameView}}</strong></p>
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                <p>Jenis Borang</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-auto">
                <p><strong>{{DistributeFormTypeView}}</strong></p>
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                <p>Nama Staf</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-auto">
                <p class="text-uppercase"><strong>{{DistributeStaffNameView}}</strong></p>
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                <p>TIN</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-auto">
                <p class="text-uppercase"><strong>{{DistributeTaxpayerRefNumView}}</strong></p>
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                <p>Tarikh Daftar</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-auto">
                <p class="text-uppercase"><strong>{{DistributeRegisterDateView}}</strong></p>
              </div>
            </div>

            <div class="row py-5">
              <div class="col-2">
                <p>Agih Kepada</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-auto">
                <select class="form-select border-0 shadow" [(ngModel)]="DistributeStaffInput" [ngModelOptions]="{standalone: true}">
                  <option value="">Senarai Staf</option>
                  <option *ngFor="let res of DistributeStaffList" [value]="res.staffID">{{res.staffName}}</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col d-flex justify-content-end align-items-end">
                <div class="btn-toolbar">
                  <div class="me-2">
                    <button data-bs-dismiss="modal" (click)="DistributeSubmit(DistributeTaxReturnFormID,DistributeStaffInput,DistributeTaxAgentIDView,DistributeTaxpayerRefNumView,DistributeFormTypeView)" type="button" class="btn submit-primary-button border-0 shadow rounded-2" role="button">Agih Semula</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Semakan Modal -->
<div class="modal fade" id="semakanModal" tabindex="-1" aria-labelledby="semakanModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content" style="background-color: rgba(223, 224, 224, 0.9);border-radius: 1.7rem !important;">
      <div class="modal-body">
        <!-- <div class="d-flex justify-content-end align-items-end">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div> -->
        <div class="d-flex justify-content-center align-items-center">
          <img src="./assets/icons/paper-pencil-yellow-circle.svg" height="90" width="90" alt="..." />
        </div>
        <p class="fw-bold text-center">Adakah anda pasti untuk membuat Semakan?</p>
        <div class="d-flex justify-content-center align-items-center pb-3 pt-3">
          <div class="d-block">
            <button class="btn button-white-table shadow" style="height: 35px; width: 102px" type="button" data-bs-dismiss="modal">Tidak</button>
            <button class="btn button-white-table shadow mx-3" style="height: 35px; width: 102px" type="button" data-bs-dismiss="modal">Ya</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Set Semula Modal -->
<div class="modal fade" id="setSemulaModal" tabindex="-1" aria-labelledby="setSemulaModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content" style="background-color: rgba(223, 224, 224, 0.9);border-radius: 1.7rem !important;">
      <div class="modal-body">
        <div class="d-flex justify-content-center align-items-center">
          <img src="./assets/icons/paper-pencil-yellow-circle.svg" height="90" width="90" alt="..." />
        </div>
        <p class="fw-bold text-center">Adakah anda pasti untuk membuat Set Semula?</p>
        <div class="d-flex justify-content-center align-items-center pb-3 pt-3">
          <div class="d-block">
            <button class="btn button-white-table shadow" style="height: 35px; width: 102px" type="button" data-bs-dismiss="modal">Tidak</button>
            <button class="btn button-white-table shadow mx-3" style="height: 35px; width: 102px" type="button" data-bs-dismiss="modal" (click)="ResetForm(TaxRefNumResetForm,FormTypeResetForm,YearAssessmentResetForm)">Ya</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Cancel Modal -->
<div class="modal fade" id="cancelModal" tabindex="-1" aria-labelledby="cancelModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content pb-5" style="background-color: #E8E8E8 !important;">
      <div class="modal-body">
        <div class="d-flex justify-content-end align-items-end pb-3">
          <button class="btn" #cancelCloseButton data-bs-dismiss="modal"><i class="bi bi-x-square-fill"></i></button>

        </div>
        <div class="row rounded-top-extra primary-colour shadow mx-3">
          <div class="col pt-2">
            <p>Sila nyatakan huraian anda kerana membatalkan pelantikan</p>
          </div>
        </div>
        <div class="row rounded-bottom-extra shadow mx-3 default-content-bg-colour">
          <div class="col m-3">
            <div class="form-floating shadow">
              <textarea class="form-control border-0" maxlength="50" placeholder="Huraian / Penjelasan :" id="huraianTextArea" style="height: 10rem" [(ngModel)]="ProcessRemarks" [ngModelOptions]="{standalone: true}"></textarea>
              <label class="text-muted" for="huraianTextArea">Huraian / Penjelasan :</label>
            </div>
          </div>
          <div class="d-flex justify-content-center align-items-center p-5">
            <button type="button" style="width: 20rem;" class="btn submit-primary-button border-0 shadow rounded-4" (click)="ProcessLantikan('Dibatalkan',ProcessRemarks)">Hantar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- CKM Acknowledgement Modal -->
<div class="modal fade" id="ckmSemakanModal" tabindex="-1" aria-labelledby="ckmSemakanModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
    <div class="modal-content pb-5" style="background-color: #E8E8E8 !important;">
      <div class="modal-body">
        <div class="d-flex justify-content-end align-items-end pb-3">
          <button class="btn" data-bs-dismiss="modal"><i class="bi bi-x-square-fill"></i></button>
        </div>
        <div class="row rounded-top-extra primary-colour shadow mx-3">
          <div class="col pt-2">
            <p>CKM Semakan pengesahan</p>
          </div>
        </div>
        <div class="row rounded-bottom-extra shadow mx-3" style="background-color: #F5F5F5 !important;">
          <div class="col m-3">
            <div class="row py-5">
              <div class="col-3">
                <p>Tahun Taksiran</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-4">
                <select class="form-select border-0 shadow" [(ngModel)]="CKMYearAssessmentInput" [ngModelOptions]="{standalone: true}">
                  <option value="">Tahun</option>
                  <option value="2023">2023</option>
                  <option value="2024">2024</option>
                  <option value="2025">2025</option>
                  <option value="2026">2026</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col d-flex justify-content-end align-items-end">
                <div class="btn-toolbar">
                  <div class="me-2">
                    <button data-bs-dismiss="modal" type="button" class="btn submit-primary-button border-0 shadow rounded-2" role="button" (click)="GetAcknowledment('CKM',CKMYearAssessmentInput,TaxpayerTINView)">Hantar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- CP22 Acknowledgement Modal -->
<div class="modal fade" id="cp22SemakanModal" tabindex="-1" aria-labelledby="cp22SemakanModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
    <div class="modal-content pb-5" style="background-color: #E8E8E8 !important;">
      <div class="modal-body">
        <div class="d-flex justify-content-end align-items-end pb-3">
          <button class="btn" data-bs-dismiss="modal"><i class="bi bi-x-square-fill"></i></button>
        </div>
        <div class="row rounded-top-extra primary-colour shadow mx-3">
          <div class="col pt-2">
            <p>CP22 Semakan pengesahan</p>
          </div>
        </div>
        <div class="row rounded-bottom-extra shadow mx-3" style="background-color: #F5F5F5 !important;">
          <div class="col m-3">
            <div class="row py-5">
              <div class="col-3">
                <p>Tahun</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-4">
                <select class="form-select border-0 shadow" [(ngModel)]="CP22YearAssessmentInput" [ngModelOptions]="{standalone: true}">
                  <option value="">Tahun</option>
                  <option value="2023">2023</option>
                  <option value="2024">2024</option>
                  <option value="2025">2025</option>
                  <option value="2026">2026</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col d-flex justify-content-end align-items-end">
                <div class="btn-toolbar">
                  <div class="me-2">
                    <button data-bs-dismiss="modal" type="button" class="btn submit-primary-button border-0 shadow rounded-2" role="button" (click)="GetAcknowledment('CP22',CP22YearAssessmentInput,TaxpayerTINView)">Hantar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
